import { Injectable, Type } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { StdFooterState } from './std-footer-state';

/**
 * StdFooterNotifier — mutaciones del pie agnóstico del layout STD.
 *
 * Este notifier es un simple "contenedor de pantalla": expone cómo montar
 * un componente dentro del pie y/o plegarlo. La decisión de QUÉ montar
 * NO vive aquí; la toma el comunicador (el notifier que maneja la
 * selección de alertas y momentos) llamando a `setComponent(...)`.
 */
@Injectable()
export class StdFooterNotifier extends BaseNotifier<StdFooterState> {
  constructor(ref: Ref) {
    super(ref, {
      component: null,
      isOpen: false,
      panelHeight: 300,
    });
  }

  /** Monta un componente en el pie. Comunica la intención, no el qué. */
  setComponent(component: Type<unknown> | null): void {
    this.updateState((s) => (s.component === component ? s : { ...s, component }));
  }

  /** Adjunta datos de contexto opcionales al componente montado. */
  setContext(context: Record<string, unknown> | undefined): void {
    this.updateState((s) => ({ ...s, context }));
  }

  open(): void {
    this.updateState((s) => (s.isOpen ? s : { ...s, isOpen: true }));
  }

  close(): void {
    this.updateState((s) => (s.isOpen ? { ...s, isOpen: false } : s));
  }

  toggle(): void {
    this.updateState((s) => ({ ...s, isOpen: !s.isOpen }));
  }

  setHeight(height: number): void {
    this.updateState((s) => (s.panelHeight === height ? s : { ...s, panelHeight: height }));
  }
}
